import PingdomScript from "./pingdom-script";

export const TrackingScripts = [PingdomScript];
